/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/goods/countGoods' }"
        >盘点单</el-breadcrumb-item
      >
      <el-breadcrumb-item>添加盘点单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input placeholder="请搜索" v-model="searchContent"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="goodTypeValue" placeholder="请选择">
          <el-option
            v-for="item in goodsTypeList"
            :key="item.value"
            :label="item.key"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 已选商品 -->

    <el-card class="box-card">
      <el-form :model="form">
      <el-form-item label="备注：">
        <el-input v-model="remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
      <div class="modt-box">已选商品</div>
      <el-table
        :data="selectedTable"
        style="width: 100%"
        max-height="250"
        label="日期"
      >
        <el-table-column fixed prop="name" label="名称"> </el-table-column>
        <el-table-column prop="salePrice" label="零售价"> </el-table-column>
        <el-table-column prop="stock" label="商品库存"> </el-table-column>
        <el-table-column prop="countNum" label="盘点库存"> </el-table-column>
        <el-table-column prop="profitNum" label="盈亏数量"> </el-table-column>
        <el-table-column prop="profitPrice" label="盈亏金额" width="120">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="editSelected(scope.$index, scope.row)"
              type="text"
              size="small"
            >
              修改
            </el-button>
            <el-button
              @click.native.prevent="deleteSelected(scope.$index, scope.row)"
              type="text"
              size="small"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px">
        <el-button @click="submitForm" type="primary">保存</el-button>
      </div>
    </el-card>
    <div class="modt-box">全部商品</div>
    <el-table :data="allGoodsTable" style="width: 100%" label="日期">
      <el-table-column fixed prop="imageUrl" label="商品图片">
      </el-table-column>
      <el-table-column prop="name" label="商品名称"> </el-table-column>
      <el-table-column prop="salePrice" label="售价"> </el-table-column>
      <el-table-column prop="costPrice" label="入货价"> </el-table-column>
      <el-table-column prop="stock" label="库存"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="addGood(scope.$index, scope.row)"
            type="text"
            size="small"
          >
            添加
          </el-button>
          <!-- <el-button
            @click.native.prevent="deleteRow(scope.$index, tableData)"
            type="text"
            size="small"
          >
            移除
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="系统库存">
              <el-input
                size="small"
                v-model="editForm.stock"
                auto-complete="off"
                placeholder="系统库存"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="盘点数量">
              <el-input
                size="small"
                v-model="editForm.countNum"
                auto-complete="off"
                placeholder="请输入盘点数量"
              ></el-input>
            </el-form-item>
            <el-form-item label="盘点价">
              <el-input
                size="small"
                v-model="editForm.countPrice"
                auto-complete="off"
                placeholder="请输入盘点价"
              ></el-input>
            </el-form-item>
            <el-form-item label="盈亏数量">
              <el-input
                size="small"
                v-model="editForm.countNum - editForm.stock"
                auto-complete="off"
                placeholder="盈亏数量"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="盈亏金额">
              <el-input
                size="small"
                v-model="
                  (editForm.countNum - editForm.stock) * editForm.countPrice
                "
                auto-complete="off"
                placeholder="盈亏金额"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button size="small" @click="sureDialog('edit')" type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import {
  getGoodsTypeList, //获取商品类型列表
  getAllGoodsList, //获取所有商品列表
  submitCountGoods, //提交盘点单
} from "@/api/api.js";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      goodTypeValue: "", //商品类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      searchContent: "", //搜索内容
      orderList: "", //订单列表
      goodName: "", //商品名称
      goodsList: [], //商品列表
      options: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ], //预下架选项
      //备注数据
      remark: "",
      editForm: {
        alarmInventory: "",
        barcode: "",
        costPrice: "",
        inventoryStock: "",
        name: " ",
        platformGoodsId: "",
        preTakedown: "",
        salePrice: "",
        stock: "",
        storeId: "",
        typeId: "",
        url: "",
        vipPrice: "",
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      selectedTable: [], //已选商品
      // 全部商品
      allGoodsTable: [], //全部商品
      selectedIndex: "", //选中的商品索引
    };
  },
  watch: {
    "editForm.countNum": function () {
      this.calculateProfitPrice();
    },
    "editForm.countPrice": function () {
      this.calculateProfitPrice();
    },
    // "selectedTable":function(){
    //   console.log(77777)
    //   // this.$forceUpdate()
    // },
    //深度监视selectedTable数组
    selectedTable: {
      handler: function (val, oldVal) {
        //判断数据里面的内容是否完全一样
        // if(val===oldVal){
        //   console.log(val, oldVal, "11111111");
        // }else{
        //   console.log(val, oldVal, "222222222");
        // }
        console.log(44444);
        // this.selectedTable = this.selectedTable
      },
      deep: true,
    },
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let date = new Date();
    this.date = date;
    // this.getdata(this.formInline);
    this.getGoodsType(); //获取商品类型列表
    this.getAllGoodsList(); //获取所有商品列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取所有商品列表
    getAllGoodsList() {
      getAllGoodsList({
        typeId: this.goodTypeValue,
        name: this.searchContent,
        pageNo: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        if (res.code == 0) {
          //给每个商品添加一个属性
          res.data.data.records.forEach((item) => {
            item.countNum = 0;
            item.countPrice = 0;
          });
          this.allGoodsTable = res.data.data.records;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data.data.total;
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    //点击搜索
    search() {
      this.getAllGoodsList();
    },
    //点击添加按钮
    addGood(index, row) {
      //判断该商品是否已经在已选商品列表中
      //   let flag = false;
      if (this.selectedTable.length == 0) {
        this.editFormVisible = true;
        this.title = "盘点";
        this.editForm = row;
      } else {
        this.selectedTable.forEach((item) => {
          if (item.id == row.id) {
            this.$message({
              message: "该商品已被选中",
              type: "warning",
            });
          } else {
            this.editFormVisible = true;
            this.title = "盘点";
            this.editForm = row;
          }
        });
      }

      // console.log(index, row, "11111111");
      //   console.log(index, row, "11111111");
    },
    //点击修改按钮
    editSelected(index, row) {
      this.editFormVisible = true;
      this.title = "修改";
      this.editForm = row;
      this.selectedIndex = index;
      // console.log(index, row, "11111111");
      //   console.log(index, row, "11111111");
    },
    //点击移除按钮
    deleteSelected(index, row) {
      this.selectedTable.splice(index, 1);
      // console.log(index, row, "11111111");
      //   console.log(index, row, "11111111");
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.formInline.limit = parm.pageSize;
      // this.getdata(this.formInline)
      this.getAllGoodsList(this.formInline);
    },
    // 编辑、增加页面保存方法
    submitForm() {
      this.$confirm("确认保存吗", "保存", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          if (this.selectedTable.length == 0) {
            this.$message({
              type: "info",
              message: "请添加商品",
            });
            return;
          } else {
            submitCountGoods({
              yzsInventoryGoodsList: this.selectedTable,
              remake: this.remark,
              storeId: localStorage.getItem("storeId"),
            }).then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "保存成功!",
                });
                this.editFormVisible = false;
                //跳转路由
                this.$router.push({
                  path: "/goods/countGoods",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消保存",
          });
        });

      // submitCountGoods({
      //   yzsInventoryGoodsList: this.selectedTable,
      //   remake: "",
      //   storeId: localStorage.getItem("storeId"),
      // }).then((res) => {
      //   if (res.code == 0) {
      //     this.$message({
      //       type: "success",
      //       message: "成功!",
      //     });
      //     this.editFormVisible = false;
      //     this.getData();
      //   } else {
      //     this.$message({
      //       type: "info",
      //       message: res.msg,
      //     });
      //   }
      // });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    calculateProfitPrice() {
      this.editForm.YinKuiJinEr =
        (this.editForm.countNum - this.editForm.stock) *
        this.editForm.countPrice;
      this.editForm.profitAmount =
        (this.editForm.countNum - this.editForm.stock) *
        this.editForm.countPrice;
      this.editForm.YinKuiShu = this.editForm.countNum - this.editForm.stock;
      this.editForm.RuKuNum = this.editForm.countNum;
      this.editForm.num = this.editForm.countNum;
      this.editForm.JinHuoJia = this.editForm.countPrice;
      this.editForm.costPrice = this.editForm.countPrice;
      this.editForm.goodsId = this.editForm.id
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.editForm = {};
      // this.$refs[formName].resetFields();
    },
    // 确定编辑、增加弹出框
    sureDialog(formName) {
      if (this.title == "修改") {
        this.selectedTable[this.selectedIndex] = this.editForm;
        // this.$forceUpdate();
      } else {
        this.selectedTable.push(this.editForm);
      }
      this.editForm = {};
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.modt-box {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f0f2f5;
  text-align: center;
  color: #334157;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 24px;
}
</style>







// WEBPACK FOOTER //
// src/views/goods/addCount.vue